export default "__VITE_ASSET__DQCn$VGN__"